import { keyframes, styled } from 'styled-components';

import { DeviceQueries } from 'Common/components/styled';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const Overlay = styled.div`
  top: 0;
  left: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 200;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .4);
  animation: ${fadeIn} 0.3s ease-out;
`;

export const ModalContainer = styled.div<{ $wide?: boolean; $maxWidth?: string }>`
  display: flex;
  color: #000;
  position: relative;
  max-width: ${({ $maxWidth }) => `calc(min(${$maxWidth ?? '429px'}, 100% - 120px))`};
  border-radius: 32px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px);
  max-height: 95vh;
  animation: ${fadeIn} 0.3s ease-out;

  @media (${DeviceQueries.mobile}) {
    max-width: calc(100% - 32px);
    border-radius: 24px;
  }
`;

export const ModalBody = styled.div`
  padding: 20px;
  flex-direction: column;
  gap: 30px;
  display: flex;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
`;

export const ModalCenteredContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 300;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  border-radius: 16px;
`;
